import { useState, useEffect, useCallback } from 'react';
import { getOrdersByBeach, updateOrderStatus, cancelOrder } from '../services/firebase';

export function useBookings(beachCode) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrders = useCallback(async () => {
    if (!beachCode) return;
    setLoading(true);
    try {
      const data = await getOrdersByBeach(beachCode);
      setOrders(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [beachCode]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const cancel = async (orderId) => {
    await cancelOrder(orderId);
    setOrders((prev) =>
      prev.map((o) => (o.id === orderId ? { ...o, status: 'cancelled' } : o))
    );
  };

  const confirm = async (orderId) => {
    await updateOrderStatus(orderId, 'confirmed');
    setOrders((prev) =>
      prev.map((o) => (o.id === orderId ? { ...o, status: 'confirmed' } : o))
    );
  };

  // Stats derivate
  const today = new Date().toISOString().split('T')[0];
  const todayOrders = orders.filter((o) =>
    o.selectedDate?.includes(today) && o.status !== 'cancelled'
  );
  const todayRevenue = todayOrders.reduce((sum, o) => sum + (o.totalPrice || 0), 0);
  const pendingCount = orders.filter((o) => o.status === 'pending').length;
  const cancelledThisWeek = orders.filter((o) => {
    if (o.status !== 'cancelled') return false;
    const created = o.createdAt?.toDate?.() || new Date(0);
    const diff = (Date.now() - created.getTime()) / 86400000;
    return diff <= 7;
  }).length;

  return {
    orders,
    loading,
    error,
    refetch: fetchOrders,
    cancel,
    confirm,
    stats: { todayOrders, todayRevenue, pendingCount, cancelledThisWeek },
  };
}
